import script from "./ViewImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewImage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__